export default __webpack_public_path__ + "static/truste-seal-cb5b498458630c5d127acf9bf0e311ba.png";